export const TypesOfSales = {
  normal: "normal",
  mtq: "mtq"
}